export const billingKeys = {
  all: ["billing"] as const,
  catalog: () => [...billingKeys.all, "catalog"] as const,
  org: (orgId: string) => [...billingKeys.all, "org", orgId] as const,
  plan: (orgId: string) => [...billingKeys.org(orgId), "plan"] as const,
  context: (orgId: string) => [...billingKeys.org(orgId), "context"] as const,
  usage: (orgId: string) => [...billingKeys.org(orgId), "usage"] as const,
  /// Under `usage`, so refreshing the usage refreshes open stats with it.
  mcpStats: (orgId: string, period: string) =>
    [...billingKeys.usage(orgId), "mcp", period] as const,
  unattached: (orgId: string) =>
    [...billingKeys.org(orgId), "unattached"] as const,
};
